module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 187
// module chunks = 0 1